import { render, staticRenderFns } from "./CampaignSetupSuppression.vue?vue&type=template&id=585b75cd&"
import script from "./CampaignSetupSuppression.vue?vue&type=script&lang=js&"
export * from "./CampaignSetupSuppression.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSetupSuppression.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports